<template>
  <v-snackbar
    v-model="model"
    class="upload-progress-toast"
    :timeout="-1"
    top
    :color="color"
  >
    <v-progress-circular
      v-if="isStillProcessing"
      class="mr-2"
      indeterminate
      size="22"
      width="2"
    />
    <v-icon v-else class="mr-2" color="white">check_circle</v-icon>
    <span class="font-weight-bold">{{ label }}</span>
    <template #action>
      <action-button color="white" elevation="0" @click="onView">
        <span :class="buttonLabelColor">{{ buttonLabel }}</span>
      </action-button>
      <icon-button
        v-if="!isStillProcessing"
        class="ml-2"
        icon="close"
        color="transparent"
        icon-color="white"
        @click="onDismiss"
      />
    </template>
  </v-snackbar>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import IconButton from '@/components/Common/IconButton';

export default {
  name: 'UploadProgressToast',
  components: { ActionButton, IconButton },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    uploadingCount: {
      type: Number,
      default: 0,
    },
    processingCount: {
      type: Number,
      default: 0,
    },
    completeCount: {
      type: Number,
      default: 0,
    },
  },
  emits: ['input', 'view'],
  computed: {
    model: {
      get: function () {
        return this.value && this.allowDisplaying;
      },
      set: function (value) {
        this.$emit('input', value);
      },
    },
    allowDisplaying() {
      return (
        this.uploadingCount > 0 ||
        this.processingCount > 0 ||
        this.completeCount > 0
      );
    },
    isStillProcessing() {
      return this.uploadingCount > 0 || this.processingCount > 0;
    },
    label() {
      if (this.uploadingCount > 0) {
        const numFiles = this.uploadingCount;
        return `Uploading ${numFiles} file${numFiles > 1 ? 's' : ''}`;
      } else if (this.isStillProcessing) {
        const numFiles = this.processingCount;
        return `Processing ${numFiles} file upload${
          numFiles > 1 ? 's' : ''
        }`;
      } else {
        const numFiles = this.completeCount;
        return `Successfully processed ${numFiles} file upload${
          numFiles > 1 ? 's' : ''
        }`;
      }
    },
    buttonLabel() {
      return this.isStillProcessing
        ? 'View Progress'
        : 'View Results';
    },
    buttonLabelColor() {
      return this.isStillProcessing ? 'info--text' : 'success--text';
    },
    buttonClickEventName() {
      return this.isStillProcessing
        ? 'view-progress'
        : 'view-results';
    },
    color() {
      return this.isStillProcessing ? 'info' : 'success';
    },
  },
  methods: {
    onView() {
      this.$emit('view');
    },
    onDismiss() {
      this.model = false;
    },
  },
};
</script>

<style lang="scss">
.upload-progress-toast .v-snack__wrapper {
  width: 520px;
}
</style>
